<div
	class="product-card {{ sectionclass }}"
	[ngClass]="{ inactive: isDisabled, active: !isDisabled }"
	(click)="allow ? navigate() : (allow = false)"
>
	<div *ngIf="showLoader">
		<div class="loader-bg"></div>
		<div class="loader-div">
			<div class="loader circle-loader-2"></div>
		</div>
	</div>
	<div class="product-card-body">
		<h2 class="card-title">
			{{ isGAM ? (isR13 ? 'Local Ads' : isLeeR13 ? 'Premium Local' : sectiontitle) : sectiontitle }}
		</h2>
		<div *ngIf="statsEnabled">
			<div class="metric" *ngFor="let metric of legend">
				<div class="metricVal {{ metric.color }}" *ngIf="!metric.noData && !isDisabled && !metric.percentValue">
					{{ metric.data }}
				</div>
				<div class="metricValu {{ metric.color }}" *ngIf="!metric.noData && !isDisabled && metric.percentValue">
					{{ metric.data }}
					<span class="metricValu {{ metric.color }}"> | {{ metric.percentData }}% </span>
				</div>
				<div *ngIf="metric.noData || isDisabled">
					<span class="noValue">--</span>
				</div>
				<span class="metricName">
					{{ metric.displayName }}
				</span>
			</div>
		</div>
	</div>
</div>
